query GetTeamAiIdentity {
    teamAiIdentity {
        userId
        userHash
    }
    loggedInUser {
        firstName
        lastName
    }
}
